import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import $ from "jquery";
import api from './api/axiosInstance';
// Define the login function
const login = async (id, email, password) => {
  try {
    const response = await api.get(
      `/Login?key=${id}&Email=${email}&Password=${password}`
    );

    if (response.data.result) {
      return { success: true, user: response.data.userDm };
    } else {
      return { success: false, message: response.data.msg };
    }
  } catch (error) {
    debugger;
    console.error('Login error:', error);
    return {
      success: false,
      message: error.response?.data?.msg || 'An error occurred during login.'
    };
  }
};

function LoginPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(null);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [organizationDetails, setOrganizationDetails] = useState(null); // New state for organization details

    useEffect(() => {
        if (!id) {
            navigate('/errorpage');
              $.alert({
                            title: "",
                            content: "Login failed. Please try again.",
                            type: "red",
                          });
            return;
        }

        // Fetch organization details
        const fetchOrganizationData = async () => {
            try {
                const response = await api.get(`/Login/GetClient?key=${id}`);
                if (response.data) {
                    setOrganizationDetails(response.data); // Store organization details
                    setIsDataFetched(true);
                } else {
                    navigate('/errorpage');
                     $.alert({
                            title: "Error",
                            content: "No data found for the provided key.",
                            type: "red",
                          });
            
                }
            } catch (error) {
                navigate('/errorpage');
                   $.alert({
                            title: "Error",
                            content: "Failed to fetch data. Please try again.",
                            type: "red",
                          });
            }
        };

        fetchOrganizationData();
    }, [id, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            alert("Please enter both email and password.");
            return;
        }
        setIsLoading(true);
        setIsDisabled(true);
        setButtonClicked('login');

        try {
            const result = await login(id, email, password);
            if (result.success) {
                debugger;
                const userDetails = result.user; // Assuming result.user contains user details
                console.log(userDetails);
                const combinedDetails = {
                    ...organizationDetails,
                    ...userDetails
                };
                localStorage.setItem('user', JSON.stringify(combinedDetails)); // Store combined object
                
             if (userDetails.isAdmin) {
    // Admin always has highest priority
    navigate('/editor/admindashboard');

} else if (userDetails.isFormDesigner && userDetails.isFormApprover) {
    // Designer + Approver but not Admin
    navigate('/editor/FormMasters');

} else if (userDetails.isFormDesigner) {
    navigate('/editor/FormMasters');

} else if (userDetails.isFormApprover) {
    navigate('/editor/FormMastersForApprover');

} else {
    navigate('/editor/MyForms');
}

                
            } else {
                  $.alert({
                            title: "Error",
                            content: result.message || "Login failed. Please try again.",
                            type: "red",
                          });   
                          return;
            }
        } catch (error) {
            alert("Login Failed: " + (error.response?.data?.msg || "An error occurred."));
        } finally {
            setIsLoading(false);
            setIsDisabled(false);
            setButtonClicked(null);
        }
    };

    const handleForgotPassword = async () => {
        const emailToReset = email;
        if (!emailToReset) {
            alert("Email is required.");
            return;
        }
        const confirmed = window.confirm("Are you sure you want to request a password reset? This will send a reset link to your email.");
        if (!confirmed) return;

        setIsDisabled(true);
        setButtonClicked('forgotPassword');

        try {
            const response = await api.post(
                `/Login/forgot-password`,
                { email: emailToReset },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
                          $.alert({
                            title: "Success",
                            content: response.data.message || "If this email is registered, you will receive a password reset link.",
                            type: "green",
                          });

        } catch (error) {
            debugger
            console.error("Forgot Password error:", error);
              $.alert({
                            title: "Error",
                            content: error.response.data.msg|| "An error occurred while requesting a password reset. Please try again.",
                            type: "red",
                          });
        } finally {
            setIsDisabled(false);
            setButtonClicked(null);
        }
    };

    // Render loading message with a spinner or welcome message
    if (!isDataFetched) {
        return (
            <div className="loading-container" style={{ textAlign: 'center', marginTop: '150px' }}>
                <img src="../images/logoimage.jpg" alt="Logo" style={{ width: '100px', marginBottom: '20px' }} />
                <h2>Welcome to Form Editor</h2>
                <p>Please wait while we fetch your organization details...</p>
                <div className="spinner-border" role="status" style={{ margin: '20px auto', width: '3rem', height: '3rem' }}>
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="login-box" style={{ margin: '150px auto' }}>
            <div className="login-logo">
                <img src="../images/logoimage.jpg" height={'100px'} width={'fit-content'} style={{ maxWidth: 'fit-content' }} alt="Logo" />
            </div>

            <div className="card">
                <div className="card-body login-card-body">
                    <p className="login-box-msg">Sign in to start your session</p>
                    <form onSubmit={handleLogin}>
                        <div className="input-group">
                            <input
                                id="txtEmail"
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={isDisabled}   
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-envelope" />
                                </div>
                            </div>
                        </div>
                        <span id="spantxtEmail" className="field-validation-valid" />

                        <div className="input-group" style={{ marginTop: 20 }}>
                            <input
                                id="txtPassword"
                                type="password"
                                className="form-control"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={isDisabled}
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-lock" />
                                </div>
                            </div>
                        </div>
                        <span id="spantxtPassword" className="field-validation-valid" />

                        <div className="row" style={{ marginTop: 20 }}>
                            <div className="col-8">
                                <button
                                    type="button"
                                    className="btn btn-info btn-block"
                                    style={{ backgroundColor: 'grey', borderColor: 'grey' }}
                                    onClick={handleForgotPassword}
                                    disabled={isDisabled}
                                >
                                    {buttonClicked === 'forgotPassword' ? "Requesting..." : "I forgot my password"}
                                </button>
                            </div>
                            <div className="col-4">
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-block"
                                    style={{ backgroundColor: 'dodgerblue', borderColor: 'dodgerblue' }}
                                    disabled={isDisabled}
                                >
                                    {buttonClicked === 'login' ? "Signing In..." : "Sign In"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
